import React from 'react';
import { Col,Container} from 'react-bootstrap';
import { TopMenu } from '../../shared';

function CopyrightPolicy() {
   
    
    return (
      <>
        <TopMenu/>
        <Col lg={12} className='inner-bg'>
            <Container className='middle-content'>
                <div className="page-heading">
                    <img src='https://pmfby.amnex.co.in/pmfby/lms/lms-inner-banner.jpg' alt='Inner Banner - LMS' className='img-fluid pb-4'/>
            <h4 className="fw-bold mb-2">Copyright Policy</h4>
             <ul className="my-topbreadcrum">
          <li>
            <a
              href="/lms"
              
            >Home</a>
          </li>
          &nbsp; / &nbsp;
          <li>Copyright Policy</li>
        </ul>
        </div>
        <div>
           <p>Contents of this website may not be reproduced partially or fully, without due permission from Department of Agriculture and Farmers Welfare, Ministry of Agriculture, Government of India. You must follow any policies made available to you within the Services.</p>
           <p>Don’t misuse our Services. For example, don’t interfere with our Services or try to access them using a method other than the interface and the instructions that we provide. You may use our Services only as permitted by law. We may suspend or stop providing our Services to you if you do not comply with our terms or policies or if we are investigating suspected misconduct.</p>
           <p>Using our Services does not give you ownership of any intellectual property rights in our Services or the content you access. You may not use content from our Services unless you obtain permission from us or are otherwise permitted by law. These terms do not grant you the right to use any branding or logos used in our Services. Don’t remove, obscure, or alter any legal notices displayed in or along with our Services.</p>
           <p>If the website is referred to as a part of another website, the source must be appropriately acknowledged. The contents of this website cannot be used in any misleading or objectionable context</p>
           </div>
            </Container>
        </Col>
        </>
    );
}

export default CopyrightPolicy;